import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, inject } from '@angular/core';

@Directive({
    selector: '[zahFocus]',
    standalone: false
})
export class FocusDirective implements AfterViewInit {
  private elementRef = inject(ElementRef);
  private changeDetector = inject(ChangeDetectorRef);

  ngAfterViewInit(): void {
    this.elementRef.nativeElement.focus();
    this.changeDetector.detectChanges();
  }
}
